import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-clock-fast-forward',
  imports: [],
  templateUrl: './clock-fast-forward.html',
  styleUrl: './clock-fast-forward.scss',
})
export class ClockFastForward {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
